export enum TabStrings {
  KatTabElement = 'KAT-TAB',
  KatTabOverflowElement = 'KAT-TAB-OVERFLOW',
  KatTabOverflowId = 'tabOverflow',
  KatHiddenTab = 'katal-hidden-tab',
  IsOverflowVisible = 'is-overflow-visible',
  OverflowSelected = 'overflow-selected',
}
